import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { messageSelector } from './selector';

import MessageSnackbar from '@/components/MessageSnackbar';
import { uiSlice } from '@/domain/ui/redux';

const Snackbar: React.FC = () => {
  const dispatch = useDispatch();
  const message = useSelector(messageSelector);
  return (
    <MessageSnackbar
      message={message}
      hideSnackbar={() => dispatch(uiSlice.actions.setMessage(undefined))}
    />
  );
};

export default Snackbar;
